// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","FuneralHeaderLarge":"FuneralHeaderLarge","innerContainer":"innerContainer","leftContent":"leftContent","logo":"logo","rightContent":"rightContent","navLinks":"navLinks","FuneralHeaderSmall":"FuneralHeaderSmall","headerTop":"headerTop","closeX":"closeX","hamburger":"hamburger","navOuter":"navOuter","items":"items","default":"default","backDrop":"backDrop"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/shared/library/FuneralHomeHeader/FuneralHomeHeader.styl
// module id = 1198
// module chunks = 0